var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.__('Insert or edit diagram'),"aria-label":_vm.__('Insert or edit diagram'),"category":"tertiary","icon":"diagram","size":"small"},on:{"click":_vm.launchDrawioEditor}})
}
var staticRenderFns = []

export { render, staticRenderFns }